import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'wastewater-m150-export',
  templateUrl: './m150-export.component.html',
  styleUrls: ['./m150-export.component.scss'],
  standalone: false,
})
export class M150ExportComponent implements OnInit {
  constructor() {}
  ngOnInit(): void {}
}
